import React from 'react';

const Vilkar: React.FC = () => {
  return (
    <div style={{ maxWidth: '900px', margin: '0 auto', padding: '2rem' }}>
      <h1>Vilkår for bruk</h1>
      
      <section style={{ marginTop: '2rem' }}>
        <h2>1. Aksept av vilkår</h2>
        <p>
          Ved å opprette en konto og bruke Sykkelfest-plattformen, godtar du disse vilkårene for bruk.
          Hvis du ikke godtar disse vilkårene, vennligst ikke bruk tjenesten.
        </p>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2>2. Beskrivelse av tjenesten</h2>
        <p>
          Sykkelfest er en plattform som kobler sammen deltakere for sosiale sykkelarrangementer
          der man spiser ulike retter hos hverandre. Arrangører kan opprette arrangement, og
          deltakere kan registrere seg i par.
        </p>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2>3. Brukerkontoer</h2>
        <p>
          For å delta i arrangement må du opprette en brukerkonto. Du er ansvarlig for å:
        </p>
        <ul>
          <li>Oppgi korrekt og oppdatert informasjon</li>
          <li>Holde passordet ditt konfidensielt</li>
          <li>Varsle oss umiddelbart om uautorisert bruk av kontoen din</li>
          <li>Sørge for at du er minst 18 år gammel</li>
        </ul>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2>4. Personvern og datasikkerhet</h2>
        <p>
          Vi tar personvernet ditt på alvor. Les vår{' '}
          <a href="/personvern" style={{ color: 'var(--primary-color)' }}>
            personvernerklæring
          </a>{' '}
          for detaljer om hvordan vi samler inn, bruker og beskytter dine personopplysninger.
        </p>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2>5. reCAPTCHA-beskyttelse</h2>
        <p>
          Denne siden er beskyttet av reCAPTCHA. Googles{' '}
          <a 
            href="https://policies.google.com/privacy" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{ color: 'var(--primary-color)' }}
          >
            personvernerklæring
          </a>{' '}
          og{' '}
          <a 
            href="https://policies.google.com/terms" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{ color: 'var(--primary-color)' }}
          >
            vilkår for bruk
          </a>{' '}
          gjelder for bruken av reCAPTCHA.
        </p>
        <p>
          Vi bruker Google reCAPTCHA v3 for å beskytte nettstedet vårt mot spam og misbruk.
          reCAPTCHA samler inn maskinvare- og programvareinformasjon, slik som enhetsdata og
          applikasjonsdata, og sender disse dataene til Google for analyse. Informasjonen som
          samles inn i forbindelse med din bruk av tjenesten vil bli brukt til å forbedre
          reCAPTCHA og for generelle sikkerhetsformål. Den vil ikke bli brukt til personlig
          tilpasset annonsering av Google.
        </p>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2>6. Oppførsel og ansvar</h2>
        <p>
          Som deltaker forplikter du deg til å:
        </p>
        <ul>
          <li>Opptre respektfullt overfor andre deltakere og verter</li>
          <li>Møte opp til arrangement du har bekreftet deltakelse på</li>
          <li>Varsle arrangør i god tid hvis du må avlyse</li>
          <li>Respektere allergier og kostpreferanser</li>
          <li>Følge trafikkregler når du sykler</li>
        </ul>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2>7. Deling av informasjon med andre deltakere</h2>
        <p>
          Når du har delt et måltid med andre deltakere i et arrangement, vil disse deltakerne
          få tilgang til viss informasjon om deg, inkludert navn, kontaktinformasjon, og
          eventuelt adresse dersom du er vert. Dette er nødvendig for gjennomføringen av
          arrangementet og for at deltakere skal kunne holde kontakten underveis.
        </p>
        <p>
          Ved å delta på arrangement aksepterer du at denne informasjonen deles med de andre
          deltakerne du sykler og spiser sammen med.
        </p>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2>8. Alkohol, beruselse og trafikksikkerhet</h2>
        <p style={{ fontWeight: 'bold', color: '#dc2626' }}>
          VIKTIG ADVARSEL: Det er forbudt å sykle i beruset tilstand etter norsk lov.
        </p>
        <p>
          I henhold til vegtrafikkloven §§ 22-23 er det straffbart å føre sykkel med
          alkoholkonsentrasjon i blodet som er høyere enn 0,2 promille, eller når påvirkning
          av alkohol eller annet berusende eller bedøvende middel er så stor at vedkommende
          ikke kan føre kjøretøyet på betryggende måte.
        </p>
        <p>
          Som deltaker er du selv fullt ansvarlig for:
        </p>
        <ul>
          <li>Ditt eget alkoholinntak under arrangementet</li>
          <li>Din egen trafikksikkerhet når du sykler mellom stoppesteder</li>
          <li>Din egen transportmåte hjem etter arrangementet</li>
          <li>Å overholde norsk lov om alkohol og trafikk</li>
        </ul>
        <p>
          Vi anbefaler sterkt at du planlegger trygg transport hjem på forhånd dersom du
          planlegger å konsumere alkohol. Dette kan inkludere drosje, kollektivtransport,
          eller å bli hentet av en edru person.
        </p>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2>9. Ansvarsbegrensning</h2>
        <p>
          Sykkelfest er en plattform som tilrettelegger for sosiale arrangement. Verken
          systemet/plattformen (Simon Skotheimsvik) eller arrangørene av enkeltarrangement
          er ansvarlige for:
        </p>
        <ul>
          <li>Matservering eller mattrygghet hos private verter</li>
          <li>Maten du spiser under arrangementet</li>
          <li>Ulykker eller skader som oppstår under arrangement</li>
          <li>Trafikksikkerhet og trafikkulykker under eller etter arrangementet</li>
          <li>Tap eller skade på personlige eiendeler</li>
          <li>Konflikter mellom deltakere</li>
          <li>Personer du møter på arrangementet</li>
          <li>Transport hjem fra arrangementet eller efterfesten</li>
          <li>Deltakeres valg om alkoholinntak eller andre substanser</li>
          <li>Deltakeres valg av transportmiddel under eller etter arrangementet</li>
        </ul>
        <p>
          <strong>
            Deltakere deltar på eget ansvar og bør ha egen forsikring. Du er selv fullt
            ansvarlig for dine handlinger, valg og din egen sikkerhet under hele arrangementet,
            inkludert transport til, fra og mellom stoppesteder.
          </strong>
        </p>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2>10. Endringer i vilkår</h2>
        <p>
          Vi forbeholder oss retten til å endre disse vilkårene når som helst. Vesentlige
          endringer vil bli varslet via e-post eller ved innlogging. Fortsatt bruk av tjenesten
          etter endringer innebærer aksept av de nye vilkårene.
        </p>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2>11. Kontaktinformasjon</h2>
        <p>
          Ved spørsmål om disse vilkårene, vennligst kontakt oss på{' '}
          <a href="/kontakt" style={{ color: 'var(--primary-color)' }}>
            kontaktsiden
          </a>.
        </p>
      </section>

      <p style={{ marginTop: '3rem', color: '#6b7280', fontSize: '0.9rem' }}>
        Sist oppdatert: {new Date().toLocaleDateString('nb-NO')}
      </p>
    </div>
  );
};

export default Vilkar;
